import { observer } from 'mobx-react-lite';
import { FC, useRef } from 'react';

import { IcMoreIcon } from '@gem/icons';
import { IconButton, IconViewSizes, PopoverMenu } from '@gem/ui-kit';

import { useGlobalActionsButtonPresenter } from './GlobalActionsButton.presenter';
import styles from './GlobalActionsButton.styles.m.css';
import { IGlobalActionsButtonProps } from './GlobalActionsButton.types';

export const GlobalActionsButton: FC<IGlobalActionsButtonProps> = observer((props) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const presenter = useGlobalActionsButtonPresenter(props);

  return (
    <>
      <IconButton
        Icon={IcMoreIcon}
        onClick={presenter.togglePopover}
        size={IconViewSizes.Big}
        theme="2"
        iconSize={IconViewSizes.Medium}
        className={styles.icon}
        setRef={buttonRef}
      />
      <PopoverMenu
        isOpened={presenter.isPopoverOpened}
        placement="top-end"
        menuItems={presenter.menu}
        reference={buttonRef.current}
        onClose={presenter.closePopover}
      />
    </>
  );
});
